import { render } from "./Profile.vue?vue&type=template&id=cc4e6d54&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=cc4e6d54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc4e6d54"]])

export default __exports__